import React from "react";
import BooleanQuestion from "./BooleanQuestion";

/**
 * True / false question.
 *
 * @param {Object} props
 * @returns {JSX.Element}
 */
export default function TrueFalseQuestion(props) {
  return <BooleanQuestion {...props} trueLabel="True" falseLabel="False" />;
}
